// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimFilterPanel-cls1_xV5","cls2":"ClaimFilterPanel-cls2_TvB ClaimFilterPanel-cls1_xV5"};